import { VisitTypeSummary, IVisitTypeSummary } from './visit-type-summary.model';
import { ServiceSummary, IServiceSummary } from './service-summary.model';
import { VisitTodaySummary, IVisitTodaySummary } from './visit-today-summary.model';
import { HouseSummary, IHouseSummary } from './house-summary';

export interface IDashboardResponse {
  visitsCurrentMonth: number;
  visitsLastMonth: number;
  currentMonthVsLastMonth: number;
  visitTypesSummary: IVisitTypeSummary[];
  servicesSummary: IServiceSummary[];
  visitsTodaySummary: IVisitTodaySummary[];
  houseSummary: IHouseSummary;
}

export class DashboardResponse {
  visitsCurrentMonth: number;
  visitsLastMonth: number;
  currentMonthVsLastMonth: number;
  visitTypesSummary: VisitTypeSummary[];
  servicesSummary: ServiceSummary[];
  visitsTodaySummary: VisitTodaySummary[];
  houseSummary?: HouseSummary;

  constructor(data: IDashboardResponse) {
    this.visitsCurrentMonth = data.visitsCurrentMonth;
    this.visitsLastMonth = data.visitsLastMonth;
    this.currentMonthVsLastMonth = data.currentMonthVsLastMonth;
    this.visitTypesSummary = data.visitTypesSummary.map(
      item => new VisitTypeSummary(item)
    );

    this.servicesSummary = data.servicesSummary.map(
      item => new ServiceSummary(item)
    );

    this.visitsTodaySummary = data.visitsTodaySummary.map(
      item => new VisitTodaySummary(item)
    );

    this.houseSummary = data.houseSummary
      ? new HouseSummary(data.houseSummary)
      : undefined;

  }
}
